import PropTypes from "prop-types";
import useVisibilityLazy from "../../hooks/useVisibilityLazy";

/**
 * Wrapper that defers rendering its children until the section scrolls
 * near the viewport (400px before becoming visible).
 *
 * Shows a lightweight placeholder while waiting, matching the same height
 * as a typical carousel section so there's no layout shift.
 *
 * @example
 * <LazySection>
 *   <TopPayingGames />
 * </LazySection>
 */
const LazySection = ({children, minHeight = 200, className = ""}) => {
  const {ref, isVisible} = useVisibilityLazy();

  return (
    <div
      ref={ref}
      className={className}
    >
      {isVisible ? children : <div style={{minHeight}} />}
    </div>
  );
};

LazySection.propTypes = {
  children: PropTypes.node.isRequired,
  minHeight: PropTypes.number,
  className: PropTypes.string,
};

export default LazySection;
